import React from 'react';
import { Spinner } from 'reactstrap';
import EChartsStackedHorizontalBarChart from '../../../../Components/Common/Charts/ECharts/EChartsStackedHorizontalBarChart';
import { generateColorGradient } from '../../../../Components/Hooks/useColorArrayHooks';

const InspectionsByAuthorityChart = ({ data, isLoading }) => {
	if (isLoading) {
		return (
			<div className='d-flex justify-content-center align-items-center py-4'>
				<Spinner size='sm' />
			</div>
		);
	}

	const series = data?.series || [];
	const yCategories = data?.authorities || [];

	if (!series.length || !yCategories.length) {
		return (
			<div className='d-flex flex-column align-items-center justify-content-center text-muted py-4 h-100'>
				<i className='ri-bar-chart-horizontal-line fs-1 mb-2'></i>
				<p className='mb-0'>Sin datos disponibles</p>
			</div>
		);
	}

	return (
		<EChartsStackedHorizontalBarChart
			series={series}
			yAxisCategories={yCategories}
			colors={generateColorGradient(series.length || 1)}
			height='100%'
		/>
	);
};

export default React.memo(InspectionsByAuthorityChart);
